var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "fieldset",
      [
        _c("h3", { staticClass: "modal-title" }, [
          _vm._v("CREATE APPLICATION")
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "f--14 m__l--12" }, [
          _vm._v("Application Type")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-type-list-options-apps" }, [
          _c(
            "div",
            {
              staticClass: "container-option",
              class: _vm.typeMode === "native" ? "option-active" : "",
              on: {
                click: function($event) {
                  _vm.selectMode("native")
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/native.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-option" }, [_vm._v("Native")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-option",
              class: _vm.typeMode === "hyperlink" ? "option-active" : "",
              on: {
                click: function($event) {
                  _vm.selectMode("hyperlink")
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/hyperlink.png") }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-option" }, [_vm._v("Hyperlink")])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.typeMode
          ? _c(
              "b-row",
              { staticClass: "p__l--10 p__r--10" },
              [
                _c("j-upload", {
                  staticClass: "upload-blank-application",
                  attrs: {
                    "accepted-file-type": [
                      "jpg",
                      "png",
                      "jpeg",
                      "bmp",
                      "xlsx",
                      "docx"
                    ],
                    "api-token": _vm.token,
                    "grid-cols": 4,
                    "label-name": "Icon",
                    "url-upload": _vm.url_upload
                  },
                  on: { url: _vm.getIcon }
                }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "8" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.application.appName.$error
                        }
                      },
                      [
                        _c("label", { attrs: { for: "appName" } }, [
                          _vm._v(" Application Name ")
                        ]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: {
                            id: "appName",
                            "error-required": false,
                            placeholder: "Enter application name here"
                          },
                          model: {
                            value: _vm.$v.application.appName.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.application.appName,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.application.appName.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.typeMode === "hyperlink",
                            expression: "typeMode === 'hyperlink'"
                          }
                        ],
                        class: {
                          "error-input": _vm.$v.application.appUrl.$error
                        }
                      },
                      [
                        _c("label", { attrs: { for: "appUrl" } }, [
                          _vm._v(" Url ")
                        ]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: {
                            id: "appUrl",
                            "error-required": false,
                            placeholder: "Enter url"
                          },
                          model: {
                            value: _vm.$v.application.appUrl.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.application.appUrl, "$model", $$v)
                            },
                            expression: "$v.application.appUrl.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.application.descName.$error
                        }
                      },
                      [
                        _c("label", { attrs: { for: "descName" } }, [
                          _vm._v(" Description ")
                        ]),
                        _vm._v(" "),
                        _c("j-textarea", {
                          attrs: {
                            id: "descName",
                            "error-required": false,
                            disabled: false,
                            placeholder: "Enter application description here"
                          },
                          model: {
                            value: _vm.$v.application.descName.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.application.descName,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.application.descName.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      [
                        _c("label", [_vm._v(" Group Application ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.groupOptions,
                            placeholder: "Select Group",
                            "error-required": false,
                            "value-format": "object"
                          },
                          model: {
                            value: _vm.selectedGroup,
                            callback: function($$v) {
                              _vm.selectedGroup = $$v
                            },
                            expression: "selectedGroup"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.typeMode === "native",
                            expression: "typeMode === 'native'"
                          }
                        ]
                      },
                      [
                        _c("label", [_vm._v(" Offline Mode ")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          model: {
                            value: _vm.$v.application.is_offline_mode.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.application.is_offline_mode,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.application.is_offline_mode.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.typeMode === "hyperlink",
                            expression: "typeMode === 'hyperlink'"
                          }
                        ]
                      },
                      [
                        _c("label", [
                          _vm._v(" Open Hyperlink in App Browser (Mobile) ")
                        ]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          model: {
                            value:
                              _vm.$v.application.open_hyperlink_in_app_browser
                                .$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.application
                                  .open_hyperlink_in_app_browser,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.application.open_hyperlink_in_app_browser.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.typeMode === "hyperlink",
                            expression: "typeMode === 'hyperlink'"
                          }
                        ]
                      },
                      [
                        _c("label", [_vm._v(" Use Token ")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          model: {
                            value: _vm.$v.application.useToken.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.application.useToken,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.application.useToken.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pull-right" },
          [
            _c(
              "b-button",
              { staticClass: "btn", on: { click: _vm.closeAppTypeModal } },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn",
                attrs: { disabled: !_vm.typeMode, variant: "primary" },
                on: { click: _vm.appType }
              },
              [_vm._v("\n        Next\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fe01122", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fe01122","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jModalAppType.vue
// module id = null
// module chunks = 